var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 279,
    viewBox: "0 0 140 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 140L-1.14441e-05 140L-1.56532e-06 27L47 27L47 140Z",
    fill: "#0C758C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 139.5L93 139.5L93 -4.06516e-06L139.5 0L139.5 139.5Z",
    fill: "#0C758C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 279L93 279L93 139.5L139.5 139.5L139.5 279Z",
    fill: "#0C758C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 139.5L0 93L139.5 93V139.5L0 139.5Z",
    fill: "#0C758C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound4);
export default __webpack_public_path__ + "static/media/not-found-4.b32ef2aa1d21b9b5163bffedc726c865.svg";
export { ForwardRef as ReactComponent };